import {
  PAYROLL_MONTHLY_EMP_OUT_IDS,
  payrollMonthlyTargetHoursForEmpOutId,
  payrollPtoDefaultDayHoursForEmpOutId,
} from "@/config/payrollMonthlyDefaults";
import {resolveTeamRowUserId} from "@/utils/timesheetRosterLookup";

function parseApiBoolean(value) {
  if (value === true || value === 1) return true;
  if (value === false || value === 0 || value == null) return false;
  if (typeof value === "string") {
    const s = value.trim().toLowerCase();
    if (s === "true" || s === "1" || s === "yes") return true;
    if (s === "false" || s === "0" || s === "no" || s === "") return false;
  }
  return false;
}

/**
 * @param {object} teamRow
 * @param {string} [empOutId] from payroll EMP roster match
 */
export function payrollFlagsForMember(teamRow, empOutId) {
  const id = empOutId || "";
  const monthlyFromEmpId = PAYROLL_MONTHLY_EMP_OUT_IDS.has(id);
  const apiReady =
    teamRow &&
    Object.prototype.hasOwnProperty.call(teamRow, "payroll_monthly_treatment");
  if (apiReady) {
    return {
      // API flag may lag (Chris is 月給 but field still false on production).
      monthlyTreatment:
        parseApiBoolean(teamRow.payroll_monthly_treatment) || monthlyFromEmpId,
      monthlyTargetHours: payrollMonthlyTargetHoursForEmpOutId(
        id,
        teamRow.payroll_monthly_hours
      ),
      ptoDefaultDayHours: payrollPtoDefaultDayHoursForEmpOutId(
        id,
        teamRow.payroll_monthly_hours
      ),
    };
  }
  if (monthlyFromEmpId) {
    return {
      monthlyTreatment: true,
      monthlyTargetHours: payrollMonthlyTargetHoursForEmpOutId(id, null),
      ptoDefaultDayHours: payrollPtoDefaultDayHoursForEmpOutId(id, null),
    };
  }
  return {
    monthlyTreatment: false,
    monthlyTargetHours: payrollMonthlyTargetHoursForEmpOutId(id, null),
    ptoDefaultDayHours: payrollPtoDefaultDayHoursForEmpOutId(id, null),
  };
}

/** @param {object[]} teamRows */
export function buildPayrollFlagsByUserId(teamRows, empReportRows) {
  const empOutByUserId = {};
  (empReportRows || []).forEach((row) => {
    if (row.userId != null) empOutByUserId[row.userId] = row.empOutId;
  });
  const map = {};
  (teamRows || []).forEach((row) => {
    const uid = resolveTeamRowUserId(row);
    if (uid == null) return;
    map[uid] = payrollFlagsForMember(row, empOutByUserId[uid]);
  });
  (empReportRows || []).forEach((row) => {
    if (row.userId == null || map[row.userId]) return;
    map[row.userId] = payrollFlagsForMember(null, row.empOutId);
  });
  return map;
}

export function teamPayrollFieldsSupported(members) {
  const list = Array.isArray(members) ? members : [];
  if (!list.length) return false;
  return list.some((m) =>
    Object.prototype.hasOwnProperty.call(m, "payroll_monthly_treatment")
  );
}
